import { makeStyles } from '@material-ui/core';

import Colours from '../../../styles/colours';

const useStyles = makeStyles(
  {
    root: {
      maxWidth: '1000px',
      margin: '20px auto',
      fontSize: '17px',
      fontWeight: 400,
      textAlign: 'center',
      padding: '10px',

      '& pre ': {
        textAlign: 'left'
      }
    }
  },
  { name: 'BzErrorFlat' }
);

export default useStyles;
